import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import _compact from 'lodash/compact'
import { createTitleGroupId } from '../../services/content/index'
import { EN } from '../../services/languages/constants'
import { getUserLanguagePrimary } from '../../services/user/index'
import SectionGraphQLManager, { SECTION_TYPES } from '../SectionGraphQLManager/index'

function SectionGaiaOracle (props) {
  const {
    promotionContentId,
    promotionContentType,
    sectionId,
    history,
    sectionIndex,
    language,
    prevSectionType,
    mhAiHidden,
    rowPlacement,
  } = props

  const titleGroupIds = _compact([createTitleGroupId(promotionContentId, promotionContentType)])

  if (titleGroupIds.length && !mhAiHidden) {
    return (
      <SectionGraphQLManager
        language={language}
        titleGroupIds={titleGroupIds}
        sectionId={sectionId}
        history={history}
        sectionIndex={sectionIndex}
        rowPlacement={rowPlacement}
        sectionType={SECTION_TYPES.GAIA_ORACLE}
        prevSectionType={prevSectionType}
      />
    )
  }

  return null
}

export default compose(
  connectRedux(
    (state, props) => {
      const { user, pmSection, featureTracking } = state
      const { sectionId } = props
      // Tabs are in the union type data, so access data.data.tabs
      const promotionContentId = pmSection.getIn([sectionId, 'data', 'data', 'tabs', '0', 'tabContent', '0', 'contentId'])
      const promotionContentType = pmSection.getIn([sectionId, 'data', 'data', 'tabs', '0', 'tabContent', '0', 'contentType'])
      const language = getUserLanguagePrimary(user) || EN

      return {
        language,
        promotionContentId,
        promotionContentType,
        mhAiHidden: featureTracking.getIn(['data', 'mhAiHidden'], false),
      }
    },
  ),
)(SectionGaiaOracle)
